/**
 * FAQ Accordion - Expansible questions functionality
 * Gerencia a abertura e fechamento dos itens do FAQ
 */

(function() {
    'use strict';

    // Função para inicializar o accordion
    function initFaqAccordion() {
        // Seleciona todos os botões de pergunta
        const faqQuestions = document.querySelectorAll('.faq-question');

        if (!faqQuestions.length) return;

        faqQuestions.forEach(question => {
            question.addEventListener('click', function() {
                // Pega o item pai (faq-item)
                const faqItem = this.closest('.faq-item');
                const isActive = faqItem.classList.contains('active');

                // Fecha todos os outros itens (accordion único)
                document.querySelectorAll('.faq-item.active').forEach(item => {
                    if (item !== faqItem) {
                        item.classList.remove('active');
                        const btn = item.querySelector('.faq-question');
                        if (btn) {
                            btn.setAttribute('aria-expanded', 'false');
                        }
                    }
                });

                // Toggle no item atual
                if (isActive) {
                    faqItem.classList.remove('active');
                    this.setAttribute('aria-expanded', 'false');
                } else {
                    faqItem.classList.add('active');
                    this.setAttribute('aria-expanded', 'true');
                }
            });
        });
    }

    // Inicializa quando o DOM estiver pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFaqAccordion);
    } else {
        initFaqAccordion();
    }

})();

